/* eslint-disable no-shadow */
import axiosUserInstance from '@/helpers/http-common';

const state = () => ({
  areReferralsActive: false,
  canBeReferred: false,
  shareReferralTitle: '',
  shareReferralText: '',
  steps: [],
  addReferrerText: '',
  referralFromUrl: null,
});

// getters
const getters = {
  isReferralAvailable: state => state.areReferralsActive && state.canBeReferred,
  referrerFromUrl: state => state.referralFromUrl,
};

  // actions
const actions = {
  init: ({ dispatch }) => new Promise((resolve, reject) => {
    dispatch('fetchReferralsDetails')
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  }),
  fetchReferralsDetails: ({ commit }) => new Promise((resolve, reject) => {
    axiosUserInstance.get('refer-a-friend-details')
      .then((response) => {
        commit('updateReferrals', {
          canBeReferred: response.data.can_add_referrer,
          areReferralsActive: response.data.referral_settings.is_active,
          shareReferralTitle: response.data.referral_settings.share_settings.share_referral_title,
          shareReferralText: response.data.referral_settings.share_settings.share_referral_text,
          steps: response.data.referral_settings.share_settings.steps,
          addReferrerText: response.data.referral_settings.add_referrer_text,
        });

        commit('user/setUserReferralCode', response.data.referral_code, { root: true });

        if (!response.data.can_add_referrer) {
          commit('updateReferralFromUrl', null);
        }

        resolve({
          isActive: response.data.referral_settings.is_active,
          referralsEarnedSum: response.data.referrals_earned_sum,
        });
      })
      .catch(() => {
        reject('Αποτυχία φόρτωσης προγράμματος πρόσκλησης φίλων.');
      });
  }),
  updateReferrerCode: ({ dispatch }, referrerCode) => new Promise((resolve, reject) => {
    if (referrerCode) {
      axiosUserInstance.post('add-referral-code', { referrerCode })
        .then((response) => {
          dispatch('setAsReferred');
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    } else {
      resolve();
    }
  }),
  setAsReferred({ commit }) {
    commit('updateCanBeReferred', false);
    commit('updateReferralFromUrl', null);
  },
  setReferralFromUrl({ commit, state }, referralFromUrl) {
    if (state.referralFromUrl === null) {
      commit('updateReferralFromUrl', referralFromUrl);
    }
  },
};

  // mutations
const mutations = {
  updateReferrals(state, {
    canBeReferred, areReferralsActive, steps,
    shareReferralTitle, shareReferralText, addReferrerText,
  }) {
    state.canBeReferred = canBeReferred;
    state.areReferralsActive = areReferralsActive;
    state.shareReferralTitle = shareReferralTitle;
    state.shareReferralText = shareReferralText;
    state.steps = steps;
    state.addReferrerText = addReferrerText;
  },
  updateCanBeReferred(state, canBeReferred) {
    state.canBeReferred = canBeReferred;
  },
  updateReferralFromUrl(state, referralFromUrl = null) {
    state.referralFromUrl = referralFromUrl;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/referrals.js